import React from 'react';
import StoresManagement from '../../../components/inventory/StoresManagement';

const Stores = () => {
  return (
    <div className="min-h-screen bg-gray-50 p-4 sm:p-6">
      <StoresManagement />
    </div>
  );
};

export default Stores;

